@if (user) {
  <div class="flex align-items-center justify-content-center">
    <form (submit)="save()" [formGroup]="form" class="mb-8 edit-form">

      <div class="flex flex-column mx-auto col-12">
        <div class="row gap-4">
          <div class="form-item field-wrapper flex align-items-center w-full gap-4 mb-5">
            <p-float-label class="w-full">
              <input pInputText
                     id="user-id"
                     type="text"
                     formControlName="userId"
                     required
                     maxlength="50"
                     [pKeyFilter]="ValidationUtils.ID_PATTERN"
                     class="w-full"
              />
              <label for="user-id" i18n>User ID</label>
            </p-float-label>

            @if (isDealerAdmin && !subId) {
              <p-float-label>
                <input pInputText
                       id="sub-user-id"
                       type="text"
                       formControlName="subId"
                       required
                       maxlength="2"
                       [pKeyFilter]="ValidationUtils.SUB_ID_PATTERN"
                >
                <label for="sub-user-id" i18n>Sub User ID</label>
              </p-float-label>
            }
          </div>
          <div class="form-item flex align-items-center w-full gap-4 mb-5">
            <p-float-label class="w-full">
              <input pInputText
                     id="name"
                     type="text"
                     formControlName="name"
                     required
                     maxlength="255"
                     [pKeyFilter]="ValidationUtils.NAME_PATTERN"
                     class="w-full"
              />
              <label for="name" i18n>Name</label>
            </p-float-label>
          </div>

          <div class="form-item flex align-items-center w-full gap-4 mb-5">
            <p-float-label class="w-full">
              <input pInputText
                     id="phone"
                     type="text"
                     formControlName="phone"
                     maxlength="25"
                     [pKeyFilter]="ValidationUtils.PHONE_PATTERN"
                     class="w-full"
              />
              <label for="phone" i18n>Phone</label>
            </p-float-label>
          </div>

          <div class="form-item flex align-items-center w-full gap-4 mb-5">
            <p-float-label class="w-full">
              <p-select
                class="w-10rem"
                id="language-code"
                type="select"
                [options]="languages"
                formControlName="language"
              />
              <label for="language-code" i18n>Language Code</label>
            </p-float-label>
          </div>

          <div class="form-item flex align-items-center w-full gap-4 mb-5">
            <p-float-label class="w-full">
              <input pInputText
                     id="email"
                     type="text"
                     formControlName="email"
                     required
                     maxlength="255"
              />
              <label for="email" i18n>E-Mail</label>
            </p-float-label>
          </div>

          <p i18n>Please make sure the password conforms to the secure password complexity policy:</p>
          <ul i18n>
            <li class="py-0 my-0">Minimum 14 characters long</li>
            <li class="py-0 my-0">Contains at least 1 upper case letter,</li>
            <li class="py-0 my-0">Contains at least 1 lower case letter,</li>
            <li class="py-0 mt-0">Contains at least 1 special character</li>
          </ul>
          @if (!this.editing && (!this.form.controls['password'].value || !this.form.controls['password'].valid)) {
            <p-message severity="warn" i18n>Please note: this user will be locked until a valid password has been set.</p-message>
          }

          <div class="form-item flex align-items-center w-full gap-4 flex-row mt-5 mb-5">
            <p-float-label class="w-full">
              <input pInputText
                     id="password"
                     type="password"
                     formControlName="password"
                     maxlength="50"
              />
              <label for="password">Password</label>
            </p-float-label>

            <p-float-label class="w-full">
              <input pInputText
                     id="confirm-password"
                     type="password"
                     formControlName="confirmPassword"
                     maxlength="50"
                     class="w-full"
              />
              <label for="confirm-password" i18n>Confirm Password</label>
            </p-float-label>
          </div>

          <div class="form-item flex align-items-center w-full gap-4 flex-row">
            <p-float-label>
              <p-datepicker styleClass="w-full"
                          dateFormat="dd/mm/yy"
                          id="userExpiration"
                          formControlName="accountExpiration">
              </p-datepicker>
              <label for="userExpiration" i18n>User Expiration</label>
            </p-float-label>

            <p-float-label>
              <p-datepicker styleClass="w-full"
                          dateFormat="dd/mm/yy"
                          id="passwordLastSet"
                          formControlName="passwordLastSet">
              </p-datepicker>
              <label for="passwordLastSet" i18n>Password Last Set</label>
            </p-float-label>
          </div>
        </div>

        <div>
          <p-divider/>

          <div class="form-item flex flex-row align-items-center gap-4 mt-5 mb-5">
            <p-float-label class="w-full">
              <input pInputText
                     id="distributor-code"
                     type="text"
                     formControlName="distributorCode"
                     maxlength="50"
                     required
                     class="w-full"
              >
              <label for="distributor-code" i18n>Distributor Code</label>
            </p-float-label>

            <p-float-label class="w-full">
              <input pInputText
                     id="station-code"
                     type="text"
                     formControlName="stationCode"
                     maxlength="50"
                     class="w-full"
              />
              <label for="station-code" i18n>Station Code</label>
            </p-float-label>
          </div>

          <div class="form-item flex flex-row mb-5 gap-4">
            <p-float-label class="w-full">
              <input pInputText
                     id="dealer-no"
                     type="text"
                     formControlName="dealerNo"
                     required
                     maxlength="10"
                     class="w-full"
              />
              <label for="dealer-no" i18n>Dealer No.</label>
            </p-float-label>

            <p-float-label class="w-full">
              <input pInputText
                     id="dealer-name"
                     type="text"
                     formControlName="dealerName"
                     maxlength="255"
                     class="w-full"
              />
              <label for="dealer-name" i18n>Dealer Name</label>
            </p-float-label>
          </div>

          <div class="form-item flex align-items-center gap-4 mb-5">
            <p-float-label class="w-full">
              <input pInputText
                     id="street"
                     type="text"
                     formControlName="street"
                     maxlength="255"
                     class="w-full"
              />
              <label for="street" i18n>Street</label>
            </p-float-label>
          </div>

          <div class="form-item flex align-items-center gap-4 mb-5">
            <p-float-label class="w-full">
              <input pInputText
                     type="text"
                     id="city"
                     formControlName="city"
                     maxlength="255"
                     class="w-full"
              />
              <label for="city" i18n>City</label>
            </p-float-label>
          </div>

          <div class="form-item flex align-items-center gap-4 mb-5">
            <p-float-label class="w-full">
              <input pInputText
                     id="postcode"
                     type="text"
                     formControlName="postcode"
                     maxlength="15"
                     class="w-10rem"
              />
              <label for="postcode" i18n>Postcode</label>
            </p-float-label>
          </div>

          <div class="form-item flex align-items-center gap-4 mb-5">
            <label class="bold" for="locked" i18n>Locked</label>
            <p-toggle-switch id="locked" formControlName="locked"/>
          </div>
          <p-divider/>
          @if (!isDealerAdmin) {
            <h3 i18n>Assign Groups</h3>
            <p-picklist
              [source]="availableGroups"
              [target]="assignedGroups"
              sourceHeader="Available"
              targetHeader="Assigned"
              filterBy="displayName,groupId"
              sourceFilterPlaceholder="Search for a group"
              targetFilterPlaceholder="Search for a group"
              [showSourceControls]="false"
              [showTargetControls]="false"
              [dragdrop]="false"
              [responsive]="true"
              [stripedRows]="true"
              [sourceStyle]="{ height: '25rem' }"
              [targetStyle]="{ height: '25rem' }"
              (onMoveToSource)="sortGroups(availableGroups); sortGroups(assignedGroups)"
              (onMoveToTarget)="sortGroups(availableGroups); sortGroups(assignedGroups)"
              (onMoveAllToSource)="sortGroups(availableGroups); sortGroups(assignedGroups)"
              (onMoveAllToTarget)="sortGroups(availableGroups); sortGroups(assignedGroups)"
              breakpoint="1400px"
            >
              <ng-template let-group pTemplate="item">
                <span>
                  @if (group.displayName) {
                    {{ group.displayName }}
                  } @else {
                    {{ group.groupId }}
                  }
                </span>
              </ng-template>
            </p-picklist>
          } @else {
            <h3 i18n>Manage Application/Page Permissions</h3>
            <p-table
              [value]="applications"
              [(selection)]="selected"
              dataKey="expertCode"
            >
              <ng-template pTemplate="header">
                <tr role="columnheader">
                  <th>
                    <p-tableHeaderCheckbox />
                  </th>
                  <th>Application Name</th>
                  <th>Expert Code</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-application>
                <tr role="row">
                  <td i18n-aria-label aria-label="Enable access to this application">
                    <p-tableCheckbox [value]="application" />
                  </td>
                  <td i18n-aria-label aria-label="Name">{{ application.name }}</td>
                  <td i18n-aria-label aria-label="Expert Code">{{ application.expertCode }}</td>
                </tr>
              </ng-template>
            </p-table>
          }
        </div>
        <!-- Only show this if the user has MFA enabled -->
        @if (id && user.mfaOption) {
          <div class="form-item flex align-items-center gap-4 my-5">
            <label class="bold" for="reset-mfa" i18n>Reset selected MFA options?</label>
            <p-toggle-switch id="reset-mfa" formControlName="resetMfa"/>
          </div>
        }
        <div class="flex flex-column my-2">
          @switch (messageType) {
            @case ('PASSWORD_NO_MATCH') {
              <p-message severity="error" closable i18n>Please make sure the passwords match!</p-message>
            }
            @case ('MISSING_PASSWORD') {
              <p-message severity="error" closable i18n>Cannot unlock account without setting a password!</p-message>
            }
            @case ('PASSWORD_INVALID') {
              <p-message severity="error" closable i18n>Please make sure the password matches the Password Policy!</p-message>
            }
            @case ('PASSWORD_INSECURE') {
              <p-message severity="error" closable i18n>Your changes have been saved, but the password was not accepted. Please ensure it fits the password policy</p-message>
            }
            @case ('FORM_INVALID') {
              <p-message severity="error" closable i18n>There are problems with your submission. Please address the fields highlighted in red</p-message>
            }
            @case ('NOT_UNIQUE') {
              <p-message severity="error" closable i18n>A User already exists with that ID. Please try another</p-message>
            }
            @case ('NOT_EXISTS') {
              <p-message severity="error" closable i18n>This user does not exist. They may have been deleted</p-message>
            }
            @case ('ERROR_SAVING') {
              <p-message severity="error" closable i18n>An error occurred while saving your changes. Please try again.</p-message>
            }
            @case ('CANNOT_DELETE_SELF') {
              <p-message severity="info" closable i18n>You cannot delete your own account</p-message>
            }
            @case ('DELETION_CANCELLED') {
              <p-message severity="info" closable i18n>User has not been deleted</p-message>
            }
            @case ('CHANGES_SAVED') {
              <p-message severity="success" closable i18n>Your changes have been saved!</p-message>
            }
          }

          <div class="form-buttons flex flex-row gap-4 justify-content-between align-items-center">
            @if (editing) {
              <button pButton type="button"
                      class="p-button warning delete"
                      (keydown.enter)="delete($event)"
                      (click)="delete($event)" i18n>Delete
              </button>
            }

            <button pButton type="button"
                    class="p-button gap-2"
                    (keydown.enter)="save()"
                    (click)="save()" i18n>Save
            </button>
            <button pButton
                    type="button"
                    class="p-button secondary gap-2"
                    (keydown.enter)="cancel()"
                    (click)="cancel()" i18n>Cancel
            </button>
          </div>
        </div>
      </div>
      <p-confirmDialog/>
    </form>
  </div>
}
